import { DataModel } from "./base-model";




export class ImportExcelModel extends DataModel  {
importExcel:any = null
}
